import React from 'react';
import moment from 'moment';
import swal from 'sweetalert';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Server from '../../../services/Server';
import I18n from '../../../locales/i18n';

import { MOMENT_SPANISH_LANG } from '../../../config/defaults';
import removeAccents from '../../../services/removeAccents';

import SubscribersLoader from './SubscribersLoader';
import SubscriberData from './SubscriberData';
import SubscribersMysql from './SubscribersMysql';
import SubscribersTemplate from './SubscribersTemplate';

import SubscribersList from './SubscribersList';

import cryptFunctions from '../../../services/cryptPassword';

moment.locale('es', MOMENT_SPANISH_LANG);

class Subscribers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			loader: false,
			bd: false,
			template: false,
			showDataSubscriber: 0,
			selectedUser: {},
			counter: {
				approved: 0,
				pending: 0,
				rejected: 0,
			},
		};

		this.onChangeStatus = this.onChangeStatus.bind(this);
		this.deleteSubscriber = this.deleteSubscriber.bind(this);
		this.handleChangeStatus = this.handleChangeStatus.bind(this);
		this.loadSubscribers = this.loadSubscribers.bind(this);
		this.handleLoader = this.handleLoader.bind(this);
		this.handleBD = this.handleBD.bind(this);
		this.handleSubscriberData = this.handleSubscriberData.bind(this);
		this.handleTemplate = this.handleTemplate.bind(this);

		this.listener = () => {};
	}
	componentDidMount() {
		this.loadSubscribers();
	}
	componentWillUnmount() {
		this.listener();
	}
	onChangeStatus(subscriber, newStatus, noAsk = false) {
		this.setState({ isLoading: true }, () => {
			if (newStatus === 'rejected' && noAsk === false) {
				swal({
					text: I18n('COMMON', 'ARE_YOU_SURE'),
					icon: 'info',
					buttons: [I18n('COMMON', 'NO'), I18n('COMMON', 'YES')],
				}).then((value) => {
					if (value) {
						this.handleChangeStatus(subscriber, newStatus);
					} else {
						this.setState({ isLoading: false });
					}
				});
			} else {
				this.handleChangeStatus(subscriber, newStatus);
			}
		});
	}
	deleteSubscriber(subscriber, needConfirmation = true) {
		if (needConfirmation) {
			swal({
				title: '',
				text: 'Se eliminará este suscriptor del listado, ¿Estas seguro?',
				icon: 'warning',
				buttons: true,
				dangerMode: true,
			}).then((willDelete) => {
				if (willDelete) {
					this.props.firebase.subCollection.delete(
						'events',
						this.props.event.id,
						'subscribers',
						subscriber.id
					);
				}
			});
		} else {
			this.props.firebase.subCollection.delete(
				'events',
				this.props.event.id,
				'subscribers',
				subscriber.id
			);
		}
	}
	handleChangeStatus(subscriber, newStatus) {
		const self = this,
			{ list, pending } = this.state,
			{ id, name, url, startDate, gmt } = this.props.event;

		try {
			list[subscriber.listIndex].status = newStatus;
		} catch (error) {
			const _tmpSubscriberArr = list.filter(
				(subs) => subs.id === subscriber.id
			);
			subscriber = _tmpSubscriberArr[0];

			list[subscriber.listIndex].status = newStatus;
		}

		if (newStatus === 'rejected' || newStatus === 'approved') {
			pending.splice(subscriber.pendingIndex, 1);
			pending.forEach((_subscriber, index) => {
				pending[index].pendingIndex = index;
			});
		}

		if (newStatus === 'pending') {
			subscriber.pendingIndex = pending.length;
			pending.push(subscriber);
		}

		const { currentUser = {}, event } = this.props,
			{ uid, customLogoLigth = false } = currentUser;

		const eventCustomLogo = event.customLogoLigth ? true : false;

		this.props.firebase.subCollection
			.update('events', id, 'subscribers', subscriber.id, {
				status: newStatus,
			})
			.then(() => {
				self.setState(
					{
						list: list,
						pending: pending,
						isLoading: false,
					},
					() => {
						if (newStatus === 'rejected') {
							Server.events.rejectUser(
								id,
								name,
								url,
								subscriber.email,
								subscriber.displayName,
								customLogoLigth,
								uid,
								eventCustomLogo
							);
						}

						if (newStatus === 'approved') {
							const { login_methods = {} } = event,
								{ code = false, email = false } = login_methods;

							const onlyCode = code && !email;

							Server.events.approveUser(
								id,
								name,
								url,
								startDate.format('DD [de] MMMM [de] YYYY, HH:mm'),
								gmt,
								subscriber.email,
								subscriber.displayName,
								customLogoLigth,
								uid,
								eventCustomLogo,
								subscriber.password,
								cryptFunctions.encode(subscriber.code),
								true,
								onlyCode
							);
						}
					}
				);
			})
			.catch((err) => {
				self.setState({ isLoading: false });
				console.error(err);
			});
	}
	handlePending(newStatus) {
		const { pending } = this.state;
		pending.forEach((subscriber) => {
			this.onChangeStatus(subscriber, newStatus, true);
		});
	}

	handleSubscriberData(subscriber) {
		this.setState({
			showDataSubscriber: moment().unix(),
			selectedUser: subscriber,
		});
	}

	loadSubscribers() {
		const self = this,
			eventId = this.props.event.id;

		this.listener = this.props.firebase.getRooms(
			'events',
			eventId,
			'subscribers',
			{ field: 'time', type: 'asc' },
			(subscribers) => {
				const list = [],
					pending = [];

				let idx = 0,
					_approved = 0,
					_rejected = 0,
					_pending = 0;

				subscribers.forEach((doc) => {
					const subscriber = doc.data();
					subscriber.id = doc.id;
					subscriber.listIndex = idx;
					subscriber.pendingIndex = pending.length;
					subscriber.code = cryptFunctions.decode(subscriber.code);
					subscriber.timeLabel = moment
						.unix(subscriber.time)
						.format('MMM DD, YYYY, HH:mm:ss');
					if (subscriber.status === 'pending') {
						pending.push(subscriber);
					}
					switch (subscriber.status) {
						case 'approved':
							_approved++;
							break;
						case 'pending':
							_pending++;
							break;
						case 'rejected':
							_rejected++;
							break;
						default:
					}
					list.push(subscriber);
					idx++;
				});

				self.setState({
					list: list,
					pending: pending,
					counter: {
						approved: _approved,
						pending: _pending,
						rejected: _rejected,
					},
				});
			}
		);
	}
	handleLoader(e) {
		this.setState({ loader: false });
	}
	handleBD(e) {
		this.setState({ bd: false });
	}
	handleTemplate(e) {
		this.setState({ template: false });
	}
	exportToExcel() {
		const { list = [] } = this.state;
		const { subscribersTemplate = [], login_methods = {}, name } = this.props.event;
		const { code = false } = login_methods;

		const data = list.map((subscriber) => {
			const row = {
				Nombre: subscriber.displayName,
				Correo: subscriber.email,
			};
			if (code) {
				row['Código de Acceso'] = subscriber.code;
			}
			subscribersTemplate.forEach((field) => {
				row[field.name] = subscriber[field.index] || '';
			});
			row['Estado'] = I18n('SUBSCRIBERS', subscriber.status);
			return row;
		});

		const worksheet = XLSX.utils.json_to_sheet(data);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Suscriptores');
		const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
		saveAs(blob, `Suscriptores ${removeAccents(name)}.xlsx`);
	}
	render() {
		const {
				list = [],
				pending = [],
				loader = false,
				bd = false,
				template = false,
			} = this.state,
			{ subscribersTemplate = [], login_methods = {} } = this.props.event,
			{ code = false } = login_methods;

		if (pending.length === 0) {
			const _arrT = document.title.split(')');
			if (_arrT.length > 1) {
				document.title = _arrT[1];
			}
		}

		if (loader) {
			return (
				<SubscribersLoader
					handleLoader={this.handleLoader}
					currentUser={this.props.currentUser}
					event={this.props.event}
				/>
			);
		}

		if (bd) {
			return (
				<SubscribersMysql
					handleLoader={this.handleBD}
					currentUser={this.props.currentUser}
					event={this.props.event}
				/>
			);
		}

		if (template) {
			return (
				<SubscribersTemplate
					handleTemplate={this.handleTemplate}
					currentUser={this.props.currentUser}
					event={this.props.event}
					firebase={this.props.firebase}
					maxCustomFields={this.props.maxCustomFields}
				/>
			);
		}

		return (
			<div className="row row-sm">
				<div className="col-md-12">
					<div className="alert alert-warning">
						Si tu evento es privado o confidencial, puedes moderar desde esta
						ventana el listado de solicitudes que haz tenido para acceder a tu
						transmisión.{' '}
						<strong>
							No olvides volver a esta pestaña y verificar constantemente si
							tienes nuevos espectadores pendientes de aprobación.
						</strong>{' '}
						También podrás exportar el listado completo de suscriptores
						aprobados junto con los datos de contacto de cada uno para que
						realices actividades de marketing directo o estes en contacto con
						ellos.
					</div>
				</div>

				<div className="col-md-12">
					<div className="card card-body">
						<div className="col-md-12 mg-t-20 tx-right">
							<button
								className="btn btn-az-primary mg-5"
								onClick={(e) => {
									this.handleSubscriberData({});
								}}
							>
								<i className="fas fa-user-plus"></i> Crear Suscriptor
							</button>
							<button
								className="btn btn-az-primary mg-5"
								onClick={(e) => {
									this.setState({ template: true });
								}}
							>
								<i className="fas fa-table"></i> Campos personalizados
							</button>
							<button
								className="btn btn-az-primary mg-5"
								onClick={(e) => {
									this.setState({ loader: true });
								}}
							>
								<i className="fas fa-upload"></i> Cargar masivamente
							</button>
							<button
								className="btn btn-az-primary mg-5"
								onClick={(e) => {
									this.setState({ bd: true });
								}}
							>
								<i className="fas fa-database"></i> Cargar desde Base de Datos
							</button>

							<button
								className="btn btn-az-primary mg-5 mg-l-40"
								onClick={(e) => {
									this.handlePending('approved');
								}}
								disabled={this.state.isLoading || pending.length === 0}
							>
								<i className="fas fa-check-double"></i> Aprobar todos
							</button>

							<button
								className="btn btn-danger mg-5"
								onClick={(e) => {
									this.handlePending('rejected');
								}}
								disabled={this.state.isLoading || pending.length === 0}
							>
								<i className="fas fa-heart-broken"></i> Rechazar todos
							</button>
						</div>
					</div>
				</div>

				<div className="col-md-12 mg-t-20">
					<div className="card card-body">
						<h4>Listado completo de Suscriptores</h4>
						<br />
						<SubscribersList
							subscribersTemplate={subscribersTemplate}
							list={list}
							handleSubscriberData={this.handleSubscriberData}
							onChangeStatus={this.onChangeStatus}
							deleteSubscriber={this.deleteSubscriber}
							isLoading={this.state.isLoading}
							counter={this.state.counter}
							currentUser={this.props.currentUser}
							event={this.props.event}
							I18n={I18n}
						/>

					<div className="col-md-12 mg-t-20 tx-right">
						<button
							className="btn btn-az-primary"
							disabled={this.state.isLoading}
							onClick={() => this.exportToExcel()}
						>
							<i className="fas fa-file-excel"></i> Exportar todos los
							Registros
						</button>
					</div>
					</div>
				</div>

				<SubscriberData
					showDataSubscriber={this.state.showDataSubscriber}
					selectedUser={this.state.selectedUser}
					subscribersTemplate={subscribersTemplate}
					firebase={this.props.firebase}
					currentUser={this.props.currentUser}
					event={this.props.event}
					eventId={this.props.event.id}
				/>
			</div>
		);
	}
}

export default Subscribers;
